import { render, staticRenderFns } from "./UsersListMobileView.vue?vue&type=template&id=9b164e98&scoped=true&"
import script from "./UsersListMobileView.vue?vue&type=script&lang=js&"
export * from "./UsersListMobileView.vue?vue&type=script&lang=js&"
import style0 from "./UsersListMobileView.vue?vue&type=style&index=0&id=9b164e98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b164e98",
  null
  
)

export default component.exports